import axios from 'axios';
import _get from 'lodash/get';

const requestURL = '/smarthelp/mmt-async-check';

// TODO :: remove this function after moving completely to new MMT service
// MMT service for page revoking
const unreadConversationChecker = () => (
  axios.get(requestURL)
    .then((response) => {
      if (_get(response, 'data.total_active_conversations') > 0) {
        return Promise.resolve({ available: true });
      }
      return Promise.resolve({ available: false });
    })
    .catch(() => Promise.reject({ available: false }))
);


// MMT service for getting last active conversation data with conversation id.
// Returning necessary data isConversationActive, serviceError in the form of object to reduce the no of conditional checks.
const getAsyncLastActiveConversation = () => (
  axios.get(requestURL)
    .then((response) => {
      const conversations = response && response.data && response.data.conversations;
      if (conversations && conversations.length) {
        return Promise.resolve({ isConversationActive: true, id: conversations[0].id, serviceError: false });
      }
      return Promise.resolve({ isConversationActive: false, serviceError: false });
    })
    .catch(() => Promise.reject({ isConversationActive: false, serviceError: true }))
);


module.exports = {
  unreadConversationChecker,
  getAsyncLastActiveConversation,
};
